<template>
    <div>
        <!-- <iframe :src="'https://trade.mql5.com/trade?demo_all_servers=1&amp;servers=FXView-Live,FXView-Live;trade_server=FXView-Demo;startup_mode=create_demo;lang=en&amp;save_password=off;utm_source=www.fxview.com;startup_version='+$route.query.platformVersion" allowfullscreen="allowfullscreen" style="width: 100%; height: 100%; border: none;"></iframe>  -->
        <iframe src="https://webtrading.broker.com/terminal?utm_source=www.fxview.com&mode=demo&lang=en&scheme=light" allowfullscreen="allowfullscreen" style="width: 100%; height: 100%; border: none;"></iframe>
    </div>
</template>
<script>
	import { fxViewMixins } from '@/plugins/fxView'
	export default {
        name: 'MT4-TRADE-LINK',
        mixins: [fxViewMixins],
        data() {
            return {
				
            }
        },
        methods:{},
        created(){}
    }
</script>

 


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/web_trade_link_live.vue